// eslint-disable-next-line no-use-before-define
import React from 'react';
import {
  connect,
  useDispatch
} from 'react-redux';
import { Redirect, Route } from 'react-router';
import { RootStateType } from '../redux-store/reducers';
import { logout } from '../redux-store/actions/auth';
import { isModuleAllowed } from '../utils/utilityFunctions';
import { NotAuthorized } from '../lib/NotAuthorized';
import { useDocumentTitle } from '../utils/useDocumentTitle';

function EmptyLayout({ children }: { children: JSX.Element }): JSX.Element {
  return <>{children}</>;
};

export type AuthRoutePropsType = {
  path: string;
  component: React.ComponentType<any>;
  isLoggedIn: boolean;
  exact?: boolean;
  role?: string;
  acceptedRoles?: string[];
  moduleCode?: string;
  permissions?: Array<Record<string, string>>;
  customAuthorizationCheck?: boolean;
  layout?: ({ children }: { children: JSX.Element; }) => JSX.Element;
  title?: string;
  description?: string;
};

function ProtectedRoute({
  component: Component,
  isLoggedIn,
  role = '',
  acceptedRoles,
  moduleCode,
  permissions,
  customAuthorizationCheck = false,
  layout: Layout = EmptyLayout,
  title,
  description,
  ...rest
}: // eslint-disable-next-line no-undef
  AuthRoutePropsType): JSX.Element {
  const dispatch = useDispatch()
  useDocumentTitle(title,description)
  const hasAcceptedRole = acceptedRoles && isModuleAllowed({ value: role, compareArr: acceptedRoles })
  const hasModulePermission = moduleCode && isModuleAllowed({ value: moduleCode, compareArr: permissions ?? [], objKey: "permissonCode" });

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isLoggedIn ? (
          // acceptedRoles?.includes(role) ? (
          (
            hasAcceptedRole ||
            hasModulePermission ||
            customAuthorizationCheck
          ) ? (
            <Layout>
              <Component key={location.pathname} {...rest} />
            </Layout>
          ) : (
            <Route
              path="*"
              // render={() => {
              //   return (
              //     <>
              //       <p>You are not authorized to view this page</p>
              //       <button onClick={() => dispatch(logout())}>Logout</button>
              //     </>
              //   );
              // }}
              render={() => {
                return <NotAuthorized />
              }}
            />
          )
        ) : (
          <Redirect to={{ pathname: '/login', state: { from: location } }} />
        )
      }
    />
  );
}
export default connect(
  ({ auth }: RootStateType) => ({ isLoggedIn: !!auth.token, role: auth.role, permissions: auth?.permissions ?? [] }),
  {}
)(ProtectedRoute);
